<template>
  <f7-app
    :params="f7params"
    :class="{ dark }">
    <f7-view
      main
      v-if="url"
      :url="url"
      :iosPageLoadDelay="200"
    />
    <TermsOfUse v-if="gtu" />
  </f7-app>
</template>

<script>
import moment from 'moment'
import TermsOfUse from '@/components/io/TermsOfUse'
import notifications from '@/mixins/notifications'
import { mapGetters, mapActions } from 'vuex'
import { gpsDefaultOptions } from '@/services/geolocation'
import routes from '@/components/routes'
export default {
  name: 'App',
  mixins: [
    notifications
  ],
  components: {
    TermsOfUse
  },
  data () {
    return {
      f7params: {
        theme: 'ios',
        routes,
        id: 'com.atlastories.app',
        navbar: {
          hideOnPageScroll: true
        }
      },
      url: null
    }
  },
  computed: {
    ...mapGetters({
      setting: 'global/setting',
      geoPos: 'global/geoPos',
      speechInstance: 'speech/speechInstance',
      availableVoices: 'speech/availableVoices'
    }),
    nosleep () {
      return this.setting('nosleep')
    },
    cache () {
      return this.setting('cache')
    },
    follow () {
      return this.setting('follow')
    },
    gps () {
      return this.setting('gps')
    },
    gtu () {
      return this.setting('gtu')
    }
  },
  methods: {
    ...mapActions({
      getVoices: 'global/getVoices',
      geoReStart: 'global/geoReStart',
      initializeSpeech: 'speech/initializeSpeech',
      setSetting: 'global/setSetting'
    }),
    init () {
      // f7 ready
      this.$f7ready(f7 => {
        // prevent lock screen
        if (this.nosleep && window.plugins && window.plugins.insomnia) window.plugins.insomnia.keepAwake()
        // get langs and voices
        this.initializeSpeech()
          .then(() => {
            this.getVoices({
              speechInstance: this.speechInstance,
              availableVoices: this.availableVoices
            })
          })
        // restart geoLocation
        if (this.geoPos && this.follow) {
          let opts = gpsDefaultOptions
          if (this.gps !== 2) opts.enableHighAccuracy = false // allow low accuracy, all 1 pos / 30s
          if (this.gps === 2) opts.maximumAge = 1000
          if (this.gps === 1) opts.maximumAge = 30000
          if (this.gps === 0) opts.maximumAge = 60000
          this.geoReStart(opts)
        }
        // online status (from notifications mixin)
        this.network()
      })
    },
    beforeunload (e) {
      // clean cache image
      const limit = moment().unix() - (86400 * this.cache)
      this.$pouch.find({
        selector: {
          type: 'ci',
          created: {
            $lt: limit
          }
        }
      }).then(result => {
        if (result.docs.length) {
          for (let doc of result.docs) {
            this.$pouch.remove(doc)
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    setInitialDarkMode () {
      let savedSettings = localStorage.getItem('settings')
      if (savedSettings) {
        savedSettings = JSON.parse(savedSettings)
        if (!savedSettings.dark && window.matchMedia && window.matchMedia('(prefers-colors-scheme: dark)').matches) {
          this.setSetting({ dark: true })
        }
      }
    }
  },
  created () {
    if (this.gtu) this.url = '/'
    else this.url = '/welcome'
    window.onbeforeunload = this.beforeunload
    this.setInitialDarkMode()
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss">
</style>
